import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useStore as useReactFlowStore } from "reactflow";
import { useReactFlow } from "reactflow";
import { fotActions } from "../store/fot";
import guideTutorialConfig, { saasWebsite, webApplication } from "../views/thinking-layout-editor/guideTutorialConfig";
import func from "@uikit/func";
import _, { find, set } from "lodash";
import { logEvent } from "@uikit/service/amplitude";
import { NOT_DISPLAY_STEPS } from "../views/thinking-layout-editor/constants";
import useFeatureTags from "./useFeatureTags";
import { useHomeUsePluginContainer } from "./HomeUsePluginRoot";
import { getIt } from "@uikit/getIt";
import { UiFunctionService } from "@uikit/service/UiFunctionService";

const patt = /^guide/;
const disableMarkEnd = {
  type: "arrowclosed",
  width: 12,
  height: 12,
  color: "#90c7f5",
};

export default function useGuideStep({
  markerEnd,
  nodeIndexRef,
  edgeIndexRef,
  getHomeNodes,
  getHomeEdges,
  setNodes,
  setEdges,
  setShowPreviewPanel,
  setSaasV2UIData,
  setSimplifiedEdgeNode,
  clickToPreviewNode,
  setStepDetachment,
  showDisableStudiosOnboarding,
}) {
  const dispatch = useDispatch();
  const { setCenter } = useReactFlow();
  const triggerNodeChanges = useReactFlowStore(state => state.triggerNodeChanges);
  const feature_tags = useFeatureTags();
  const enable_saas_web = feature_tags.enable_saas_web;
  const platform = enable_saas_web === true ? "saasV2" : "saas";

  const [guidePublishData, setGuidePublishData] = useState({
    selectedArr: [],
  });
  const [isLastStepGuidePage, setIsLastStepGuidePage] = useState(false);

  const stepRef = useRef(0);
  const aiSaasV2Ref = useRef(null);
  const { aiSaasState } = useHomeUsePluginContainer();
  const aiSaasRef = aiSaasState.aiSaasRef;
  // const aiSaasRef = useRef(null)
  const configRef = useRef(_.cloneDeep(guideTutorialConfig.onboarding));

  useEffect(() => {
    set(guideTutorialConfig, "onboarding.8.hint", enable_saas_web === true ? saasWebsite : webApplication);
    configRef.current = _.cloneDeep(guideTutorialConfig.onboarding);
  }, [enable_saas_web]);

  const imagicaStudioTutorial = useSelector(state => state.fot.imagicaStudioTutorial);
  const setImagicaStudioTutorial = val => {
    dispatch(fotActions.setImagicaStudioTutorial(val));
  };

  const {
    saasAndThinkState: { setSaasUIData },
  } = useHomeUsePluginContainer();

  function resetPreviewData() {
    setSaasV2UIData({
      appName: "Storyboard AI",
      appTitle: "Storyboarding Made Easy with AI",
      appUseCase1: "Bring your ideas to Life",
      appUseCase2: "Create Interactive Storyboards",
      appUseCase3: "Plotting with AI",
      newPreviewCase: "",
      appTagline: "Unleash your creativity - Generate a storyboard from an idea!",
      inputSuggestion:
        'You can ask for a storyboard for any idea you have. Example queries could be "Create a storyboard for a horror movie" or "Can you generate a storyboard for a comedy sketch',
      placeholder: "Enter something ...",
      input: [],
      output: [],
    });
  }

  function handleStepStart() {
    // 没有权限
    if (!showDisableStudiosOnboarding) return;
    nodeIndexRef.current = 1;
    edgeIndexRef.current = 0;
    setImagicaStudioTutorial({ ...imagicaStudioTutorial, showGuide: true });
    getIt(UiFunctionService).dirty();
    const positionX = document.body.clientWidth / 2 - 280;
    const positionY = document.body.clientHeight / 2;
    setCenter(positionX, positionY, {
      duration: 500,
      zoom: 1,
    });
    setNodes([]);
    setEdges([]);
    resetPreviewData();
    logEvent("start_tutorial", { new_user: !imagicaStudioTutorial.viewed });
  }
  function mvCurrentStepCenter(step, setFoucs, currNodeId) {
    const nodes = getHomeNodes();
    const currNode = nodes.find(x => x.id === currNodeId);
    const currNodePositionY = currNode?.position?.y || 0;

    let positionX = 0;
    let positionY = 458 + 230 / 2;
    let zoom = 0.6;

    switch (step) {
      case 1:
        //第一个node右边100，y为node中心
        positionX = 480 - 100;
        zoom = 0.8;
        break;
      case 2:
        //第一个node右边100，y为node中心
        positionX = 480 + 280 + 100;
        zoom = 0.8;
        break;
      case 3:
        positionX = 1100;
        zoom = 1;
        break;
      case 4:
        //editor-1的X，editor-0的Y
        positionX = 1100 + 280 / 2;
        break;
      case 5:
        positionX = 1100 + 280 / 2;
        positionY = currNodePositionY;
        zoom = 0.8;
        break;
      case 6:
        positionX = 1850;
        break;
      case 7:
        positionX = 2200;
        break;
      case 8:
        positionX = 2700;
        break;
      default:
        return;
    }

    setFoucs(positionX, positionY, {
      duration: 500,
      zoom,
    });
  }
  const stepPosition = step => {
    const nodes = getHomeNodes();
    const groupArr = nodes.filter(x => x.type === "customGroup");
    const guideData = nodes.find(x => x.id === "editor-1");
    const customGroupData = groupArr[groupArr.length - 1];
    const firstGroup = groupArr[0];

    const firstGroupHeight = firstGroup?.style?.height || customGroupData?.height;
    // const customGroupDataHeight = customGroupData?.style?.height || customGroupData?.height
    const customGroupDataWidth = customGroupData?.style?.width || customGroupData?.width;
    const guideDataHeight = guideData?.style?.height || guideData?.height;
    const guideDataWidth = guideData?.style?.width || guideData?.width;

    switch (step) {
      case 1:
        return {
          x: 130,
          y: 385,
        };
      case 2:
        return {
          x: 780,
          y: 395,
        };
      case 3:
        return {
          x: 1180,
          y: 386,
        };
      case 4:
        return {
          x: 1500,
          y: guideData.position.y + guideDataHeight / 2 - 207.5,
        };
      case 5:
        return {
          x: 1500,
          y: guideData.position.y - 238,
        };
      case 6:
        const getCenterY = guideData.position.y + guideDataHeight / 2;
        const getCenterX = customGroupData.position.x + customGroupDataWidth;
        return {
          x: getCenterX + 66,
          y: getCenterY - 187,
        };
      case 7:
        return {
          x: firstGroup.position.x + 300,
          y: firstGroup.position.y + firstGroupHeight / 2 - 480,
        };
      case 8:
        return {
          x: 2662,
          y: 362,
        };
      default:
        return {
          x: 810,
          y: 398,
        };
    }
  };
  const handleAddNodes = (currentGuide, nodesParam, step) => {
    const guideConfigNodes = currentGuide?.nodes || [];
    const originNodes = nodesParam.map(x => {
      const guideConfigNode = guideConfigNodes.find(y => y.id === x.id) || {};

      if (patt.test(x.id)) {
        return {
          ...x,
          ...guideConfigNode,
          data: {
            ...x.data,
            ...(guideConfigNode?.data || {}),
            hint: currentGuide.hint,
            step,
          },
        };
      }
      if (!func.isEmpty(guideConfigNode)) {
        return {
          ...x,
          ...guideConfigNode,
          data: {
            ...x.data,
            ...(guideConfigNode?.data || {}),
            hint: currentGuide.hint,
            step,
          },
        };
      }
      return x;
    });

    const nodes = getHomeNodes();
    let newList = nodes.map(x => {
      if (patt.test(x.id)) {
        const currOriginNode = originNodes.find(y => y.id === x.id);
        return {
          ...x,
          ...(currOriginNode || {}),
          position: stepPosition(step),
          data: {
            ...x.data,
            ...(currOriginNode?.data || {}),
            hint: currentGuide.hint,
            step,
          },
        };
      }
      const currOriginNode = originNodes.find(y => y.id === x.id);
      if (!func.isEmpty(currOriginNode)) {
        return {
          ...x,
          ...currOriginNode,
          data: {
            ...x.data,
            ...currOriginNode.data,
          },
        };
      }
      return x;
    });
    const filterOriginNodes = originNodes.filter(y => !newList.some(x => x.id === y.id));
    if (!func.isEmpty(filterOriginNodes)) {
      newList = [...filterOriginNodes, ...newList];
    }
    return newList.map(x => setSimplifiedEdgeNode(x));
  };
  const handleAddEdges = (currentGuide, edgesParam, step) => {
    const guideConfigEdges = currentGuide?.edges || [];
    const originEdges = edgesParam.map(x => {
      const guideConfigEdge = guideConfigEdges.find(y => y.id === x.id) || {};

      if (!func.isEmpty(guideConfigEdge)) {
        return {
          ...x,
          ...guideConfigEdge,
          data: {
            ...x.data,
            ...(guideConfigEdge?.data || {}),
            hint: currentGuide.hint,
            step,
            lineParam: {
              ...x.data.lineParam,
              ...(guideConfigEdge?.data?.lineParam || {}),
            },
          },
        };
      }
      return x;
    });

    const edges = getHomeEdges();
    let newList = edges.map(x => {
      const currOriginEdge = originEdges.find(y => y.id === x.id);
      if (!func.isEmpty(currOriginEdge)) {
        return {
          ...x,
          ...currOriginEdge,
          data: {
            ...x.data,
            ...currOriginEdge.data,
            lineParam: {
              ...x.data.lineParam,
              ...currOriginEdge.data.lineParam,
            },
          },
        };
      }
      return x;
    });
    const filterOriginEdges = originEdges.filter(y => !newList.some(x => x.id === y.id));
    if (!func.isEmpty(filterOriginEdges)) {
      newList = [...newList, ...filterOriginEdges];
    }
    return newList.map(x => setSimplifiedEdgeNode(x));
  };
  function setGuideData(nodes, edges, step) {
    const currentGuide = configRef.current.find(x => x.step === step);

    // 更新旧值，添加新值
    const newNodes = handleAddNodes(currentGuide, nodes, step);
    setNodes(newNodes);
    const newEdges = handleAddEdges(currentGuide, edges, step);
    setEdges(newEdges);
    // 将最新nodes/edges存到config
    currentGuide.nodes = newNodes;
    currentGuide.edges = newEdges;
    // 脱离画布 step

    if (NOT_DISPLAY_STEPS.includes(step)) {
      setStepDetachment(currentGuide);
      handleStep(0);
    }

    if (step === 6) {
      const groupNode = find(newNodes, node => node.id === "group-2");
      const defaultEditor = find(newNodes, node => node.id === "editor-0");

      if (defaultEditor && groupNode) {
        const getCenterY = defaultEditor.position.y + defaultEditor.height / 2;
        const {
          id,
          style: { height },
          position,
        } = groupNode;
        triggerNodeChanges([
          {
            id,
            type: "position",
            position: {
              ...position,
              y: getCenterY - height / 2,
            },
          },
        ]);
      }
    }
  }
  function handleStep(step) {
    const stepObj =
      step instanceof Object
        ? step
        : {
            step,
          };
    // 加载中隐藏 Step
    setNodes(prevList => {
      return prevList.map(x => {
        if (patt.test(x.id)) {
          return {
            ...x,
            data: {
              ...x.data,
              ...stepObj,
            },
          };
        }
        return x;
      });
    });
  }
  function handleStep1(step, setFoucs) {
    handleStepStart();
    const nodes = [
      {
        id: "guideNode-0",
        type: "customNode",
        position: stepPosition(step),
        data: {
          displayType: "guideNode",
        },
      },
      {
        id: "editor-0",
        width: 280,
        height: 230,
        type: "customNode",
        position: {
          x: 480,
          y: 458,
        },
        data: {
          textAreaValue: "A cute panda",
          displayType: "text",
          guideNodeAutoFocus: true,
          guideNodeEditable: true,
        },
      },
    ];
    setGuideData(nodes, [], step);
    mvCurrentStepCenter(step, setFoucs);
  }
  function handleStep2(step, setFoucs) {
    const nodes = [
      {
        id: "guideNode-0",
        type: "customNode",
        position: stepPosition(step),
      },
      {
        id: "editor-0",
        width: 280,
        height: 230,
        type: "customNode",
        position: {
          x: 480,
          y: 458,
        },
        data: {
          isShowRightAddIcon: true,
          guideNodeAutoFocus: false,
          guideNodeEditable: false,
        },
      },
    ];
    setGuideData(nodes, [], step);
    mvCurrentStepCenter(step, setFoucs);
  }
  function handleStep3(step, setFoucs) {
    mvCurrentStepCenter(step, setFoucs);
    const nodes = [
      {
        id: "editor-0",
        data: {
          // 新增
          isShowRightAddIcon: false,
          guideDisableNode: true,
          // availableEl: []
        },
      },
      {
        id: "editor-1",
        width: 280,
        height: 230,
        type: "customNode",
        position: {
          x: 1200,
          y: 458,
        },
        data: {
          textAreaValue: "",
          displayType: "text",
        },
      },
    ];
    const edges = [
      {
        id: "edge-0",
        type: "customEdge",
        animated: true,
        source: "editor-0",
        target: "editor-1",
        sourceHandle: "b",
        targetHandle: "a",
        markerEnd: markerEnd,
        data: {
          sourceHandle: "b",
          targetHandle: "a",
          isGetQuery: false,
          guideDisableAiDescriptionInput: true,
          notAutoBlur: true,
          guideDisableRunBtn: false,
          // guideAiDescriptionList: 值来自于config
        },
      },
    ];
    setGuideData(nodes, edges, step);
  }
  async function handleStep4(step, setFoucs) {
    mvCurrentStepCenter(step, setFoucs);
    const edges = [
      {
        id: "edge-0",
        type: "customEdge",
        markerEnd: disableMarkEnd,
        data: {
          guideDisableRunBtn: true,
          guideDisableEdge: true,
          guideAiDescriptionList: [],
        },
      },
    ];
    setGuideData([], edges, step);
  }
  function handleStep5(step, setFoucs) {
    const nodes = [
      {
        id: "editor-1",
        type: "customNode",
        data: {
          guideShowTop: true,
        },
      },
    ];
    setGuideData(nodes, [], step);
    mvCurrentStepCenter(step, setFoucs, "editor-1");
  }
  function handleStep6(step, setFoucs) {
    mvCurrentStepCenter(step, setFoucs);
    const nodes = [
      {
        id: "editor-1",
        type: "customNode",
        data: {
          guideShowTop: false,
          guideDisableNode: true,
        },
      },
      {
        id: "group-2",
        type: "customGroup",
        data: {
          // 新增
          isShowRightAddIcon: true,
          // availableEl: ['rightAddIcon']
        },
      },
    ];
    const edges = [
      {
        id: "edge-1",
        type: "customEdge",
        markerEnd: disableMarkEnd,
        data: {
          // 新增
          guideDisableRunBtn: true,
          guideDisableEdge: true,
        },
      },
    ];
    setGuideData(nodes, edges, step);
  }
  function handleStep7(step, setFoucs) {
    mvCurrentStepCenter(step, setFoucs);
    let nodes = [
      {
        id: "guideNode-0",
        type: "customNode",
        data: {
          highlightStrs: ["/"],
        },
      },
      {
        id: "group-2",
        type: "customGroup",
        data: {
          // 新增
          isShowRightAddIcon: false,
          // availableEl: []
        },
      },
    ];
    // 获取group-2下的所有子node并禁用
    const currNodes = getHomeNodes();
    const currGroupChildNodes = currNodes.filter(x => x.parentNode === "group-2");
    const disableGroupChildNodes = currGroupChildNodes.map(x => {
      return {
        ...x,
        data: {
          ...x,
          guideDisableNode: true,
        },
      };
    });
    nodes = nodes.concat(disableGroupChildNodes);

    const edges = [
      {
        id: "edge-2",
        type: "customEdge",
        data: {
          // 新增
          guideAiDescription: "",
          guideNeedEnterAiDescription: "/",
          guideDisableAiDescriptionInput: false,
          // availableEl: ['Generate an Image '],
          notAutoBlur: true,
        },
      },
    ];
    setGuideData(nodes, edges, step);
  }
  function handleStep8(step, setFoucs) {
    mvCurrentStepCenter(step, setFoucs);
    const edges = [
      {
        id: "edge-2",
        type: "customEdge",
        data: {
          // 新增
          guideAiDescription: null,
          guideDisableRunBtn: true,
          guideDisableEdge: true,
          // availableEl: [],
        },
      },
    ];
    // 获取edge-2的target的group下的所有子node并禁用
    const currEdges = getHomeEdges();
    const currEdge = currEdges.find(x => x.id === "edge-2");
    const currNodes = getHomeNodes();
    const currGroupChildNodes = currNodes.filter(x => x.parentNode === currEdge.target);
    // const disableGroupChildNodes = currGroupChildNodes.map(x => {
    //   return {
    //     ...x,
    //     data: {
    //       ...x,
    //       guideDisableNode: true
    //     }
    //   }
    // })
    // enable publish按钮
    setIsLastStepGuidePage(true);
    setGuideData(currGroupChildNodes, edges, step);
  }
  // 显示publish app选择界面
  function handleStep9(step) {
    setIsLastStepGuidePage(false);
    setGuidePublishData({
      selectedArr: [platform],
    });
    setGuideData([], [], step);
  }
  // 自动添加image group作为saasv2 app的outputs
  function handleStep10(step) {
    // bsf-4912 use setSassUIData
    setSaasUIData(prev => ({ ...prev, output: [] }));
    resetPreviewData();
    setIsLastStepGuidePage(false);
    setStepDetachment({});
    // 将app滚动条滚动至底部
    setShowPreviewPanel(true);
    const nodes = getHomeNodes();
    const edges = getHomeEdges();
    const finalGroupId = edges.find(x => x.id === "edge-2").target;
    const finalGroupChildNodes = nodes.filter(x => x.parentNode === finalGroupId);
    clickToPreviewNode(finalGroupChildNodes[0], platform);
    finalGroupChildNodes.forEach(x => {
      setTimeout(() => {
        if (enable_saas_web) {
          aiSaasV2Ref.current?.scrollTo();
        } else {
          aiSaasRef.current?.scrollTo();
        }
      }, 1000);
    });
  }
  function handleStep11(step, setFoucs, isReturn) {
    setIsLastStepGuidePage(false);
    setStepDetachment({});
    setImagicaStudioTutorial({
      ...imagicaStudioTutorial,
      showGuide: false,
      viewed: true,
    });
    getIt(UiFunctionService).dirty();

    configRef.current = _.cloneDeep(guideTutorialConfig.onboarding);
    if (isReturn) return;
    // 这里需要重置所有nodes/edges中的禁用属性
    const nodes = getHomeNodes();
    const edges = getHomeEdges();
    const nodeResetAttrs = {
      types: ["customNode", "customGroup"],
      attrs: [
        { key: "isShowRightAddIcon", value: false },
        { key: "guideDisableNode", value: false },
        { key: "guideShowTop", value: false },
        { key: "guideNodeAutoFocus", value: false },
        { key: "guideNodeEditable", value: false },
      ],
    };
    const edgeResetAttrs = {
      types: ["customEdge"],
      attrs: [
        { key: "guideDisableEdge", value: false },
        { key: "guideDisableAiDescriptionInput", value: false },
        { key: "guideDisableRunBtn", value: false },
        { key: "notAutoBlur", value: false },
        { key: "guideAiDescriptionList", value: [] },
      ],
    };
    const resetNodes = nodes.map(x => {
      let data = {
        ...x.data,
      };
      if (nodeResetAttrs.types.includes(x.type)) {
        nodeResetAttrs.attrs.forEach(y => {
          if (x.data.hasOwnProperty(y.key)) {
            data[y.key] = y.value;
          }
        });
      }
      return {
        ...x,
        data,
      };
    });
    const resetEdges = edges.map(x => {
      let data = {
        ...x.data,
      };
      if (edgeResetAttrs.types.includes(x.type)) {
        edgeResetAttrs.attrs.forEach(y => {
          if (x.data.hasOwnProperty(y.key)) {
            data[y.key] = y.value;
          }
        });
      }
      return {
        ...x,
        markerEnd,
        data,
      };
    });
    setNodes(resetNodes);
    setEdges(resetEdges);
    // const eventProperties = {
    //   sessionId: tutorialSessionId
    // }
    // logEvent('finish_tutorial', eventProperties)
    // setTutorialSessionId('');
  }
  function clickStep(step, setFoucs = setCenter, isReturn = false) {
    stepRef.current = step;
    const stepHandleObj = {
      0: handleStep,
      1: handleStep1,
      2: handleStep2,
      3: handleStep3,
      4: handleStep4,
      5: handleStep5,
      6: handleStep6,
      7: handleStep7,
      8: handleStep8,
      9: handleStep9,
      10: handleStep10,
      11: handleStep11,
    };
    stepHandleObj[step]?.(step, setFoucs, isReturn);
  }
  function clickBackStep(setFoucs = setCenter) {
    setIsLastStepGuidePage(false);
    // 清空当前step保存的数据
    setStepDetachment({});
    const currGuide = configRef.current.find(x => x.step === stepRef.current);
    const originConfig = guideTutorialConfig.onboarding.find(x => x.step === stepRef.current);
    currGuide.nodes = originConfig?.nodes || [];
    currGuide.edges = originConfig?.edges || [];
    // 上一步
    stepRef.current--;
    const prevGuide = configRef.current.find(x => x.step === stepRef.current);
    if (stepRef.current === 6) {
      const groupNode = find(prevGuide.nodes, node => node.id === "group-2");
      const defaultEditor = find(prevGuide.nodes, node => node.id === "editor-0");

      if (defaultEditor && groupNode) {
        const getCenterY = defaultEditor.position.y + defaultEditor.height / 2;
        const {
          id,
          style: { height },
          position,
        } = groupNode;
        groupNode.height = height;
        groupNode.position = {
          ...position,
          y: getCenterY - height / 2,
        };
      }
      const currGuideNode = prevGuide.nodes.find(x => x.id === "guideNode-0");
      currGuideNode.position = {
        y: currGuideNode.position.y,
        x: groupNode.position.x + 370,
      };
    }
    if (NOT_DISPLAY_STEPS.includes(stepRef.current)) {
      if (stepRef.current === 8) {
        setStepDetachment(Object.assign({}, { ...prevGuide }, { backStep: true }));
        setIsLastStepGuidePage(true);
      }
      if (stepRef.current === 9) {
        setStepDetachment(Object.assign({}, { ...prevGuide }, { backStep: true }));
      }
      if (stepRef.current === 10) {
        setStepDetachment(prevGuide);
      }
      handleStep(0);
    }
    setNodes(prevGuide.nodes);
    setEdges(prevGuide.edges);
    mvCurrentStepCenter(stepRef.current, setFoucs);
  }

  return {
    guidePublishData,
    stepRef,
    aiSaasV2Ref,
    aiSaasRef,
    handleStep,
    clickStep,
    clickBackStep,
    isLastStepGuidePage,
  };
}
